import React, { useCallback } from "react";

import { FormInstance } from "antd/es/form";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import useZohoPrimaryContactConfirm from "@app/component/activity/useZohoPrimaryContactConfirm";

import FormValues from "../types/FormValues";

// Form flavour of the Zoho primary-contact confirm: reads the type and people off the form at
// click time, so it never acts on a stale render.
const useZohoPrimaryContactSaveConfirm = (
  activityTypes: ActivityType[],
  form: FormInstance<FormValues>,
  isZohoOrganization: boolean,
  onSave: () => void
): [() => void, React.ReactElement] => {
  const [confirmIfNeeded, contextHolder] = useZohoPrimaryContactConfirm(isZohoOrganization);

  const handleSave = useCallback(() => {
    const { activityTypeId, peopleIds } = form.getFieldsValue();
    confirmIfNeeded(
      activityTypes.find(({ id }) => id === activityTypeId),
      peopleIds?.length ?? 0,
      onSave
    );
  }, [activityTypes, confirmIfNeeded, form, onSave]);

  return [handleSave, contextHolder];
};

export default useZohoPrimaryContactSaveConfirm;
